function TitleWithStarIcon({
                               title,
                               fontSize = "12px",
                               fontFamily = "Inter, Arial, sans-serif",
                               fontWeight = 600,
                               marginTop = "0px",
                           }) {
    return (<div
        style={{
            display: "flex",
            gap: "5px",
            color: "grey",
            fontSize: fontSize,
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            marginTop: marginTop,
        }}

    >
        <span style={{color: "red"}}>*</span>
        <span>{title}</span>
    </div>);
}

function TitleWithOutStarIcon({
                                  title,
                                  fontSize = "12px",
                                  fontFamily = "Inter, Arial, sans-serif",
                                  fontWeight = 600,
                                  marginTop = "0px",
                                  padding = "5px"
                              }) {
    return (<div
        style={{
            display: "flex",
            padding: padding,
            color: "grey",
            fontSize: fontSize,
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            marginTop: marginTop,
        }}

    >

        <span>{title}</span>
    </div>);
}

export {TitleWithStarIcon, TitleWithOutStarIcon}